import { render, staticRenderFns } from "./registration copy.vue?vue&type=template&id=20ec6738&"
import script from "./registration copy.vue?vue&type=script&lang=js&"
export * from "./registration copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports